import blue from './blue.mjs';
import common from './common.mjs';
import coolNeutral from './coolNeutral.mjs';
import cyan from './cyan.mjs';
import green from './green.mjs';
import lightBlue from './lightBlue.mjs';
import lime from './lime.mjs';
import neutral from './neutral.mjs';
import orange from './orange.mjs';
import pink from './pink.mjs';
import purple from './purple.mjs';
import red from './red.mjs';
import violet from './violet.mjs';
import redOrange from './redOrange.mjs';

// src/theme/atomic/index.ts
var atomic_default = {
  blue,
  common,
  coolNeutral,
  cyan,
  green,
  lightBlue,
  lime,
  neutral,
  orange,
  pink,
  purple,
  red,
  violet,
  redOrange
};

export { atomic_default as default };
